"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRallyDriverStencil = exports.rallyDriverStencilDefinition = void 0;
const properties_1 = require("../properties");
const crew_member_property_1 = require("../properties/crew-member.property");
const no_monetization_property_1 = require("../properties/no-monetization.property");
const participating_disciplines_property_1 = require("../properties/participating-disciplines.property");
const partner_profiles_property_1 = require("../properties/partner-profiles.property");
const product_related_image_property_1 = require("../properties/product-related-image.property");
const product_related_quote_property_1 = require("../properties/product-related-quote.property");
const seo_title_property_1 = require("../properties/seo-title.property");
const social_links_property_1 = require("../properties/social-links.property");
const social_title_property_1 = require("../properties/social-title.property");
const social_wall_property_1 = require("../properties/social-wall.property");
const soft_facts_property_1 = require("../properties/soft-facts.property");
const sound_bite_property_1 = require("../properties/sound-bite.property");
const subheading_property_1 = require("../properties/subheading.property");
const surname_property_1 = require("../properties/surname.property");
const track_records_property_1 = require("../properties/track-records.property");
const uri_title_property_1 = require("../properties/uri-title.property");
const url_property_1 = require("../properties/url.property");
const website_property_1 = require("../properties/website.property");
exports.rallyDriverStencilDefinition = {
    view: {
        label: 'Rally Driver',
        category: 'person',
        group: 'Persons & Groups',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'subheading',
                    'teaser',
                    'story-content',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'url',
                            'featured-media',
                            'featured-video',
                            'backdrop-media',
                        ],
                    },
                    {
                        name: 'Hard facts',
                        items: [
                            'gender',
                            'first-name',
                            'surname',
                            'driver-type',
                            'crew-member',
                            'sound-bite',
                            'product-related-quote',
                            'product-related-image',
                            'date-of-birth',
                            'place-of-birth',
                            'location-of-nationality',
                            'participating-disciplines',
                            'career-start',
                        ],
                    },
                    {
                        name: 'Soft facts',
                        items: ['soft-facts'],
                    },
                    {
                        name: 'Track records',
                        items: ['track-records'],
                    },
                    {
                        name: 'Social links',
                        items: [
                            'social-links',
                            'social-wall',
                            'website',
                        ],
                    },
                    {
                        name: 'Partners',
                        items: ['partner-profiles'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'standalone',
                            'is-currently-active',
                            'no-monetization',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-rally-drivers',
                    'tag-rally-teams',
                    'related-content',
                ],
            },
        ],
    },
    content: {
        'backdrop-media': properties_1.backdropMediaPropertyDefinition,
        'career-start': properties_1.careerStartPropertyDefinition,
        'content-categories': properties_1.contentCategoriesPropertyDefinition,
        [crew_member_property_1.crewMemberPropertyDefinition.name]: crew_member_property_1.crewMemberPropertyDefinition,
        'date-of-birth': properties_1.dateOfBirthPropertyDefinition,
        disciplines: {
            ...properties_1.disciplinesPropertyDefinition,
            constraints: [
                properties_1.disciplinesPropertyDefinition.constraints[0],
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: ['discipline'],
                },
            ],
        },
        [properties_1.driverTypePropertyDefinition.name]: properties_1.driverTypePropertyDefinition,
        'featured-media': properties_1.featuredMediaPropertyDefinition,
        'featured-title': properties_1.featuredTitlePropertyDefinition,
        'featured-video': properties_1.featuredVideoPropertyDefinition,
        'first-name': properties_1.firstNamePropertyDefinition,
        gender: properties_1.genderPropertyDefinition,
        'header-media': {
            ...properties_1.headerMediaPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: [
                        'image',
                        'video',
                        'episode-video',
                        'film',
                        'recap-video',
                        'trailer-video',
                        'video-channel',
                    ],
                },
            ],
        },
        [properties_1.isCurrentlyActivePropertyDefinition.name]: properties_1.isCurrentlyActivePropertyDefinition,
        'location-of-nationality': properties_1.locationOfNationalityPropertyDefinition,
        'no-monetization': no_monetization_property_1.noMonetizationPropertyDefinition,
        'participating-disciplines': participating_disciplines_property_1.participatingDisciplinesPropertyDefinition,
        'partner-profiles': partner_profiles_property_1.partnerProfilesPropertyDefinition,
        'place-of-birth': properties_1.placeOfBirthPropertyDefinition,
        'product-related-image': product_related_image_property_1.productRelatedImagePropertyDefinition,
        'product-related-quote': product_related_quote_property_1.productRelatedQuotePropertyDefinition,
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        'related-content': properties_1.relatedContentPropertyDefinition,
        'search-terms': properties_1.searchTermsPropertyDefinition,
        'seo-title': seo_title_property_1.seoTitlePropertyDefinition,
        'social-links': social_links_property_1.socialLinksPropertyDefinition,
        'social-title': social_title_property_1.socialTitlePropertyDefinition,
        'social-wall': social_wall_property_1.socialWallPropertyDefinition,
        'soft-facts': soft_facts_property_1.softFactsPropertyDefinition,
        'sound-bite': {
            ...sound_bite_property_1.soundBitePropertyDefinition,
            view: { label: 'Driver quote' },
        },
        standalone: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        [properties_1.storyContentPropertyDefinition.name]: properties_1.storyContentPropertyDefinition,
        subheading: subheading_property_1.subheadingPropertyDefinition,
        surname: surname_property_1.surnamePropertyDefinition,
        'tag-event-series': properties_1.tagEventSeriesPropertyDefinition,
        'tag-events': properties_1.tagEventsPropertyDefinition,
        [properties_1.tagRallyDriversPropertyDefinition.name]: properties_1.tagRallyDriversPropertyDefinition,
        [properties_1.tagRallyTeamsPropertyDefinition.name]: properties_1.tagRallyTeamsPropertyDefinition,
        teaser: properties_1.teaserPropertyDefinition,
        title: properties_1.titlePropertyDefinition,
        'track-records': track_records_property_1.trackRecordsPropertyDefinition,
        'uri-title': uri_title_property_1.uriTitlePropertyDefinition,
        url: url_property_1.urlPropertyDefinition,
        website: website_property_1.websitePropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: ['erc', 'wrc'],
    name: 'rally-driver',
};
const isRallyDriverStencil = (stencil) => {
    return stencil.name === exports.rallyDriverStencilDefinition.name;
};
exports.isRallyDriverStencil = isRallyDriverStencil;
//# sourceMappingURL=data:application/json;base64,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